import { Badge2 } from "@/ui2/atoms/Badge";
import type { NoteHistoryEvent } from "@/core/types";

import { EVENT_TO_VARIANT_MAP } from "../constants";

type NoteHistoryStatusBadgeProps = {
  cosignature_status: NoteHistoryEvent["cosignature_status"];
  label: string;
};

export function NoteHistoryStatusBadge({ cosignature_status, label }: NoteHistoryStatusBadgeProps) {
  return (
    <Badge2 appearance="outline" size="sm" variant={EVENT_TO_VARIANT_MAP[cosignature_status]}>
      {label}
    </Badge2>
  );
}
